import { render, staticRenderFns } from "./propagation.vue?vue&type=template&id=576dfdf6&scoped=true&"
import script from "./propagation.vue?vue&type=script&lang=js&"
export * from "./propagation.vue?vue&type=script&lang=js&"
import style0 from "./propagation.vue?vue&type=style&index=0&id=576dfdf6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576dfdf6",
  null
  
)

export default component.exports